import axios from "../lib/axios";
import { getCloudFunctionUrl } from "../utils/cloudFunctions";

const EXPORT_VIDEO_EDITOR_TIMEOUT_MS = 540000;

export const exportVideoEditorProjectRequest = async ({
  token,
  path,
  edl,
}) => {
  const { data } = await axios({
    method: "post",
    url: `${getCloudFunctionUrl("exportVideoEditorProject")}/exportVideoEditorProject`,
    data: {
      path,
      edl,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: EXPORT_VIDEO_EDITOR_TIMEOUT_MS,
  });

  return data;
};
